import { Role } from './role.interface'
import { Company } from './company.interface'
import { PersonType } from './person-type.enum'

export enum UserType {
    CLIENT = 'CLIENT',
    COMPANY = 'COMPANY',
    CUSTOM = 'CUSTOM',
    EMPLOYEE = 'EMPLOYEE',
    MASTER = 'MASTER',
    PARTNER = 'PARTNER',
    PROFESSIONAL = 'PROFESSIONAL',
    /** Usuário operado por IA (docs/ai-user.md). */
    AI = 'AI',
}

// Reexportado para não quebrar quem já importa `PersonType` daqui.
export { PersonType }

export enum MediatorStatus {
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED',
    PENDING_APPROVAL = 'PENDING_APPROVAL',
    INACTIVE = 'INACTIVE',
    ACTIVE = 'ACTIVE',
    SUSPENDED = 'SUSPENDED',
    EXPIRED = 'EXPIRED',
}

export interface MediatorApprovalProcess {
    id: number
    userId: number
    documentation: boolean
    documentationApprovedBy: string | null
    commercialProposal: boolean
    commercialProposalApprovedBy: string | null
    contract: boolean
    contractApprovedBy: string | null
    onboarding: boolean
    onboardingApprovedBy: string | null
    createdAt: string
    updatedAt: string
}

export enum Gender {
    MALE = 'MALE',
    FEMALE = 'FEMALE',
    OTHER = 'OTHER',
}

export interface AccessibleCompany {
    id: number
    name: string
    tradingName?: string | null
    logoUrl?: string | null
    organizationId?: number | null
}

export interface UserCompanyAssignment {
    id?: number
    companyId: number
    roleId: number
    isDefault?: boolean
    active?: boolean
    company?: {
        id: number
        name: string
        tradingName?: string | null
        logoUrl?: string | null
    }
    role?: Role
}

export interface User {
    id: number
    userType: UserType | null
    /** Instruções de comportamento do usuário de IA (`userType` AI). */
    aiInstructions?: string | null
    name: string
    email: string
    password: string | null
    emailVerified: boolean
    emailVerificationToken: string | null
    emailVerificationTokenExpires: string | null
    picture: string | null
    // Role/company ativos vêm do payload JWT (resolvidos do UserCompany da company ativa).
    // Não são colunas do User — são injetados via setCredentials/switchCompany.
    roleId: number | null
    role: Role | null
    companyId: number | null
    company: Company | null
    organizationId: number
    accessibleCompanies?: AccessibleCompany[]
    accessibleCompanyIds?: number[]
    // Vínculos persistidos em UserCompany (usados em form de criação/edição)
    companies?: UserCompanyAssignment[]
    invitedById: number | null
    invitedBy: User | null
    invitedUsers: User[]
    inviteStatus: number | null
    phone: string | null
    cpf: string | null
    cnpj: string | null
    birthDate: string | null
    formation: string | null
    active: boolean
    createdAt: string
    updatedAt: string
    personType: PersonType
    street: string | null
    number: string | null
    complement: string | null
    neighborhood: string | null
    city: string | null
    state: string | null
    zipCode: string | null
    country: string | null
    mediatorStatus: MediatorStatus
    language: string | null
    timezone: string | null
    notifications: boolean
    hasMediationExperience: string | null
    hasHealthExperience: string | null
    experienceTime: string | null
    mediatorApprovalProcess?: MediatorApprovalProcess | null
    pillar: string | null
    bio: string | null
    links: string[] | null
    gender: Gender | null
    professionalId?: number | null
    partnerId?: number | null
    partner?: {
        id: number
        name: string
        tradingName?: string | null
        logoUrl?: string | null
        email?: string | null
        phone?: string | null
        whatsappNumber?: string | null
        cnpj?: string | null
        cpf?: string | null
        personType?: string | null
        street?: string | null
        number?: string | null
        neighborhood?: string | null
        city?: string | null
        state?: string | null
        zipCode?: string | null
    } | null
    clientId?: number | null
    planModules?: Record<string, string[]> | null
}
